import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ActivityTable } from '../../components/activity';
import LoadScreen from '../../components/load-screen/LoadScreen';

import { withFirebase } from '../../firebase';
import { fetchActivity, resetActivity } from '../../actions/activityActions';

import './activity-page.scss';

const ActivityPage = (props) => {
  const {
    activityList,
    activityLoaded,
    activityLoading,
    users,
    fetchActivity,
    resetActivity,
  } = props;

  useEffect(() => {
    if (!activityLoaded) {
      fetchActivity();
    }

    return () => {
      resetActivity();
    };
  }, [activityLoaded, fetchActivity, resetActivity]);

  const loading = !activityLoaded && activityLoading;

  return (
    <div className="activity-page">
      {loading && <LoadScreen />}
      <ActivityTable activityList={activityList} users={users} />
    </div>
  );
};

ActivityPage.propTypes = {
  activityLoaded: PropTypes.bool,
  activityLoading: PropTypes.bool,
  activityList: PropTypes.array,
  users: PropTypes.array,
  fetchActivity: PropTypes.func,
  resetActivity: PropTypes.func,
};

const mapStateToProps = (state) => ({
  activityList: state.activity.list,
  activityLoading: state.activity.loading,
  activityLoaded: state.activity.isLoaded,
  users: state.users.list || [],
});

const mapDispatchToProps = (dispatch) => ({
  fetchActivity: () => dispatch(fetchActivity()),
  resetActivity: () => dispatch(resetActivity()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFirebase(ActivityPage));
